<template>
  <div class="ChineseSystem">
    <div class="cs_m30">
      <img src="/static/app/cs_banner.jpg" class="banner" />
      <!-- 初级 -->
      <div class="cs_level level1">
        <div class="title">初级 （BEGINNER’S）</div>
        <div class="heng"></div>
        <div class="csl_gray">
          <!-- <p>零基础华裔少儿及非华裔少儿</p>
          <p>(针对零基础)</p> -->
          <p>中文零基础少儿(针对零基础)</p>
        </div>
        <img src="/static/app/cs_img1.png?v=20210813" class="img_biao" />
        <div class="csl_tags">
          <img src="/static/app/cs_tag1.png" class="cs_tag" />
          <div class="gray">
            中文听说能力非常有限或完全不具备，从小生活在非中文语言环境的零基础华裔少儿，或非华裔少儿。
          </div>
          <img src="/static/app/cs_tag2.png" class="cs_tag" />
          <div class="gray">
            以《快乐汉语》、《轻松学中文》及《轻松学中文》（少儿版）为蓝本进行精细化、适应性编撰，涵盖YCT考试的常用词语和相关语法知识。
          </div>
        </div>
      </div>
      <!-- 中级 -->
      <div class="cs_level level2">
        <div class="title">中级 （INTERMEDIATE）</div>
        <div class="heng"></div>
        <div class="csl_gray">
          <p>具备基本听说能力的华裔少儿</p>
          <p>(针对海外出生的华裔孩子)</p>
        </div>
        <img src="/static/app/cs_img2.png" class="img_biao" />
        <div class="csl_tags">
          <img src="/static/app/cs_tag1.png" class="cs_tag" />
          <div class="gray">
            具备中文基本听说能力，但表达能力十分有限且读写能力欠缺的华裔少儿。
          </div>
          <img src="/static/app/cs_tag2.png" class="cs_tag" />
          <div class="gray">
            以“汉字树阶梯识字体系”及“中文自然分级体系”为理论基础，同时参照了YCT、IGCSE、IB和AP等国际通行的中文考试大纲词汇进行精心编写。
          </div>
        </div>
      </div>
      <!-- 高级 -->
      <div class="cs_level level3">
        <div class="title">高级 （ADVANCED）</div>
        <div class="heng"></div>
        <div class="csl_gray">
          <p>曾接受过中国义务教育的新移民家庭少儿</p>
          <p>(针对新移民)</p>
        </div>
        <img src="/static/app/cs_img3.png" class="img_biao" />
        <div class="csl_tags">
          <img src="/static/app/cs_tag1.png" class="cs_tag" />
          <div class="gray">
            适合具备较好的中文听说能力和一定水平识字量（800字以上）（例如：在国内上过一段时间小学,具备与国内同龄小朋友一样的听说能力的新移民家庭孩子），希望能系统地学习中文，在学习内容上又能与国际先进教学内容与方法结合，广泛涉猎，提高认知，开阔视野，从而在“听-说-读-写”的语言应用能力，以及“认知-思考-拓展”的认知思维能力上同时获得长足进步的少儿。
          </div>
          <img src="/static/app/cs_tag2.png" class="cs_tag" />
          <div class="gray">
            以中文自然分级体系为理论基础，参照YCT、IGCSE、IB和AP等国际通行的中文考试大纲词汇进行精心编写，全面覆盖中国小学部编教材内的全部知识点，但在内容编撰上完全摆脱了中国小学课本内容因社会环境和背景不同而带来的客观局限和适应性缺失，采取以美国分级阅读教育体系为科学标准，把中文语言教学通过“人物”、“生活”、“自然”、“科学”、“探索”、“故事”六个跨学科领域进行巧思的内容设计，让课程真正适合海外华裔少儿的实践需求、认知发展需求和多元文化适应性需求。
          </div>
        </div>
      </div>
    </div>
    <div class="cs_bottom">
      <div class="title">考拉知道课件示例</div>
      <van-swipe :loop="true"  class="swiper"  :width="width" initial-swipe="1" indicator-color="#E6212B">
        <van-swipe-item class="s_item">
            <img src="https://www.koalaknow.com/img/img/6192ecdd37fb7c2ed6033db39ec7f427.gif"/>
        </van-swipe-item>
        <van-swipe-item class="s_item">
            <img src="https://www.koalaknow.com/img/img/1ef1c18213020129da8cb5ce6dd9d10f.gif" />
        </van-swipe-item>
        <van-swipe-item class="s_item">
            <img src="https://www.koalaknow.com/img/img/8c8ad987c9cedf8c11a8e7b963a3c71a.gif" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="cs_btn" v-if="InternalPay==0">
      <img src="/static/app/cs_btn_shadow.png"/>
      <div class="btn" @click="to_buy">立即购买</div>
    </div>
  </div>
</template>
<script>
import { Swipe, SwipeItem } from "vant";
import http from '../../../service/http';
export default {
  name: "ChineseSystem",
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  data(){
      return{
          width:0,
          guid:'',
          InternalPay:1
      }
  },
  mounted() {
    document.title = "考拉知道〡中文系统课程";
    this.width=document.body.clientWidth-30;
    this.guid=http.getQueryString('guid');
    this.InternalPay=http.getQueryString('InternalPay');
    if(this.guid==0 || this.guid=='' ||this.guid==undefined ||this.guid==null) {
      this.InternalPay=1;
    }
  },
  methods:{
    to_buy(){
      window.location.href="https://www.koalaknow.com/Vchar/Index?app=app&guid="+this.guid+"&islogin=true"
    }
  }
};
</script>
<style scoped>
.ChineseSystem {
  background: #fff;
  text-align: center;
}
.cs_m30 {
  padding: 40px 30px 0;
  box-sizing: border-box;
}
.cs_m30 .banner {
  width: 100%;
  border-radius: 20px;
}
.cs_level {
  margin: 75px 0 0 0;
  color: #333333;
}
.cs_level .title {
  font-size: 36px;
  line-height: 36px;
  font-weight: bold;
}
.cs_level .heng {
  width: 480px;
  height: 2px;
  background: #e6212b;
  margin: 20px auto;
}
.cs_level .csl_gray {
  color: #666666;
  font-size: 24px;
  line-height: 30px;
}
.cs_level .img_biao {
  width: 100%;
  display: block;
  margin: 10px auto 0;
}
.csl_tags {
  padding: 8px 0 0 0;
  box-sizing: border-box;
  text-align: left;
}
.csl_tags .cs_tag {
  margin: 30px 0 0 0;
  display: block;
  width: 140px;
}
.csl_tags .gray {
  font-size: 20px;
  margin: 20px 0 0 0;
  line-height: 30px;
}
.cs_bottom {
  margin: 75px 0 163px 0;
}
.cs_bottom .title {
  font-size: 36px;
  font-weight: bold;
}
.cs_bottom .swiper{
    margin: 30px 0 0 0;
    width: 100vw;
}
.swiper{
    height: 421px;
}
.swiper .s_item{
    height: 368px;
    /* padding:0 10px; */
    /* margin: 0 0 0 20px; */
    border-width: 0 10px;
    border-style: solid;
    border-color: #fff;
    box-sizing: border-box;
}
 .swiper .s_item:last-child{
     /* margin: 0 20px; */
     box-sizing: border-box;
 }
.swiper .s_item img{
    width: 100%;
}
.swiper >>> .van-swipe__track{
  margin-left: 30px;
}
.swiper >>> .van-swipe__indicator{
    width: 12px;
    height: 12px;
    background-color: #CCCCCC;
}
.cs_btn{
  position: fixed;
  height: 109px;
  width: 100%;
  bottom: 0;
  z-index: 2;
  background: #fff;
}
.cs_btn img{
  width: 100%;
}
.cs_btn .btn{
  width: 600px;
height: 70px;
background: #E6212B;
border-radius: 35px;
line-height: 70px;
font-size: 36px;
font-weight: bold;
color: #fff;
margin: 13px auto 0;
}
</style>


// WEBPACK FOOTER //
// src/components/App/Chinese_system.vue